import React from 'react'
import FilterItemsModule from './FilterItems.module.scss'

const FilterComponent = ({ filterItems, setFilterItems }) => {
  const handleFilterItemsCheckboxChange = (type) => (e) => {
    const updatedFilterItems = { ...filterItems, [type]: e.target.checked }

    // Ensure at least one of `ai` or `student` is true
    if (!updatedFilterItems.ai && !updatedFilterItems.student) {
      alert('AI発言か生徒発言のどちらかを必ず選択してください')
      return
    }

    setFilterItems(updatedFilterItems)
  }

  return (
    <div className={FilterItemsModule['filters-container']}>
      <div className={FilterItemsModule['filters-sub-container']}>
        <label>
          AI発言
          <input type="checkbox" checked={filterItems.ai} onChange={handleFilterItemsCheckboxChange('ai')} />
        </label>
        <label>
          生徒発言
          <input type="checkbox" checked={filterItems.student} onChange={handleFilterItemsCheckboxChange('student')} />
        </label>
        <label>
          形容詞
          <input
            type="checkbox"
            checked={filterItems.adjective}
            onChange={handleFilterItemsCheckboxChange('adjective')}
          />
        </label>
        <label>
          動詞
          <input type="checkbox" checked={filterItems.verb} onChange={handleFilterItemsCheckboxChange('verb')} />
        </label>
      </div>
    </div>
  )
}

export default FilterComponent
